import { jsx as _jsx } from "react/jsx-runtime";
import { Image } from '../../core/components/Image';
import { ScreenSize, useScreenSize } from '../../core/util/MediaQueries';
export const Contact3DHeader = (props) => {
    const { variant = 'secondary' } = props;
    const screenSize = useScreenSize();
    const height = screenSize === ScreenSize.Large ? (variant === 'primary' ? '20%' : '8%') : undefined;
    const flexBasis = screenSize === ScreenSize.Large ? undefined : '60px';
    const imageHeight = screenSize === ScreenSize.Large ? '80%' : variant === 'primary' ? '100px' : '57px';
    const imageMargin = (screenSize === ScreenSize.Large && variant === 'secondary') ? 'auto 0' : 'auto';
    return (_jsx("div", { style: { display: 'flex', flexDirection: 'row', padding: '0 ' + '24px', height, flexBasis, width: '100%', boxSizing: 'border-box' }, children: _jsx(Image, { style: { height: imageHeight, margin: imageMargin }, src: 'images/contact-3d-logo.png' }) }));
};
//# sourceMappingURL=Contact3DHeader.js.map